import React from 'react';

const PrivacyPolicy = () => {
    return (
        <>
            <h2 className="policy-title">Privacy Policy – Blossom & Bond</h2>
            <p>At Blossom & Bond, located in The Hague, we value the privacy of our community. This policy explains how we handle your personal data.</p>

            <h3 className="policy-subtitle">1. Data Controller</h3>
            <p>The person responsible for your data is Annely Bravo, contactable at blossombond@gmail.com.</p>

            <h3 className="policy-subtitle">2. What data do we collect?</h3>
            <p>We only collect the information necessary to manage your class bookings: your name, email address, phone number, and (optionally) your baby’s name/age.</p>

            <h3 className="policy-subtitle">3. Purpose of Processing</h3>
            <p>Your data is used exclusively to:</p>
            <ul className="policy-list">
                <li>Process and confirm your bookings.</li>
                <li>Send you essential information about your scheduled classes.</li>
                <li>If you opt-in, send you our newsletter (which you can unsubscribe from at any time).</li>
            </ul>

            <h3 className="policy-subtitle">4. Data Storage</h3>
            <p>We use Firebase (Google Cloud) to store your data securely. We do not sell or share your personal information with third parties.</p>

            <h3 className="policy-subtitle">5. Your Rights</h3>
            <p>Under the AVG/GDPR, you have the right to access, rectify, or delete your data. To exercise these rights, please contact us at blossombond@gmail.com.</p>
        </>
    );
};

export default PrivacyPolicy;
